import { render, staticRenderFns } from "./GiftCardsList.vue?vue&type=template&id=6930e247&"
import script from "./GiftCardsList.vue?vue&type=script&lang=ts&"
export * from "./GiftCardsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports